import { Icon } from '@dealstack/frontend/shared/components/fundament/Icon/Icon';
import { Text } from '@dealstack/frontend/shared/components/fundament/Text/Text';
import { rem } from '@mantine/core';
import styled from 'styled-components';
import {
	PredefinedIconSize,
	PredefinedIcons,
} from '@dealstack/frontend/shared/components/fundament/Icon/Icon.types';
import { PredefinedTextVariants } from '@dealstack/frontend/shared/components/fundament/Text/Text.types';

export interface props {
	icon?: PredefinedIcons;
	iconSize?: PredefinedIconSize;
	children?: string | React.ReactNode;
	textVariant?: PredefinedTextVariants;
}

export const TopContent = ({ icon, children, iconSize, textVariant }: props) => {
	const textInString = typeof children === 'string';
	const iconInString = typeof icon === 'string';
	return (
		<TopContentWrapper>
			{iconInString ? <Icon size={iconSize} variant={icon} /> : icon}
			{textInString ? (
				<Text disableVariantMapping variant={textVariant}>
					{children}
				</Text>
			) : (
				children
			)}
		</TopContentWrapper>
	);
};

const TopContentWrapper = styled.div`
	align-self: stretch;
	flex-grow: 0;
	display: flex;
	flex-direction: row;
	justify-content: flex-start;
	align-items: center;
	gap: ${rem(4)};
	padding: 0;
	color: ${({ theme }) => theme.v2.color.neutral[300]};

	${Icon}.svg {
		width: ${rem(16)};
		height: ${rem(16)};
	}
`;
